import * as styledComponents from 'styled-components';
import { rgba } from 'polished';
window.ANTD_VARS = ANTD_VARS;
const theme = Object.assign({}, ANTD_VARS, { '@hover-color': rgba(ANTD_VARS['@primary-color'], 0.1) });
const { default: styled, css, createGlobalStyle, keyframes, ThemeProvider, } = styledComponents;
export { css, createGlobalStyle, keyframes, ThemeProvider, theme };
export default styled;
